import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, NavigationExtras, Router } from '@angular/router';
import { ActionSheetController, AlertController, IonInfiniteScroll, LoadingController, ModalController, NavParams, Platform, ToastController } from '@ionic/angular';
import { Observable, Subscription } from 'rxjs';
import { filter, map, take } from 'rxjs/operators';
import { HandicapSystem, HandicapCalculation, ClubHandicap, HandicapGameRound, PlainScoreCard, ScorecardList, PlayerInfo, PlayerHomeInfo } from 'src/data/mygolf.data';
import {  PlayerList } from 'src/data/player-data';
// PlayerInfo,
import { MessageDisplayUtil } from 'src/message-display-utils';
import { CommonProvider } from '../commonServices/common';
import { Apiurl } from '../commonServices/route';
import { ScorecardService } from 'src/providers/scorecard-service/scorecard-service';

import { adjustViewZIndex } from 'src/globals';
import { SearchCriteria } from 'src/data/search-criteria';
import { CompetitionService } from 'src/providers/competition-service/competition-service';
import { PlayerService } from 'src/providers/player-service/player-service';
import { Country } from 'src/data/country-location';
import { HandicapRound } from 'src/data/handicap-history';
import { HandicapService } from 'src/providers/handicap-service/handicap-service';
import { HandicapIndexSubscription } from 'src/data/premium-subscription';
import { Keyboard } from '@awesome-cordova-plugins/keyboard/ngx';
import { PlayerHomeActions } from 'src/redux/player-home/player-home-actions';
import { ClubFlightService } from 'src/providers/club-flight-service/club-flight-service';
import { PlayerListPage } from '../modal-screens/player-list/player-list.page';
import { ScorecardFilterPage } from '../scorecard-filter/scorecard-filter.page';
import { Location } from '@angular/common';
import { ChangeHcpHistoryComponent } from './change-hcp-history/change-hcp-history.component';
import { CommonPullupMenuComponent } from '../modal-screens/common-pullup-menu/common-pullup-menu.component';
import { PlayerVoucherPage } from '../modal-screens/player-voucher/player-voucher.page';
import { HandicapMembershipService } from 'src/providers/handicap-membership/handicap-membership.service';
import { JsonService } from 'src/json-util';
import { PlayerHomeDataService } from 'src/redux/player-home';
import { mygolfUtils } from 'src/custom/mygolf2u-utils';

// import { isPresent } from '@ionic-angular/';

export interface HandicapGameRoundExt extends HandicapGameRound {
  showMore?: boolean;
}
@Component({
  selector: 'app-handicap-history',
  templateUrl: './handicap-history.page.html',
  styleUrls: ['./handicap-history.page.scss'],
})
export class HandicapHistoryPage {
  @ViewChild(IonInfiniteScroll) infiniteScroll: IonInfiniteScroll;
  scorecardList: ScorecardList;
  searchQuery: string = "";
  refreshAttempted: boolean = false;
  currentPlayer: PlayerInfo;
  searchCriteria: SearchCriteria;
  selectedCountry: Country;
  handicapHistory: HandicapCalculation;
  gameRounds: Array<HandicapGameRoundExt>;
  clubHandicap: Array<ClubHandicap>;
  fromMenu: string = '';
  searchPlayers: string = "";
  players: Array<PlayerInfo> = [];
  playersToExclude: Array<PlayerInfo> = [];
  selectedPlayerId: number;
  player: PlayerInfo;
  player$: Observable<PlayerInfo>;
  dtLength: number = 0;
  loader: any;
  hcpIdxSubs: HandicapIndexSubscription;
  subsActive: boolean = true;
  playerSubs: boolean;
  navigationExtras: NavigationExtras = {};
  handicapSystem: Array<HandicapSystem>;
  modalData: any;
  seeMore: boolean = false;
  viewHcpSystem: HandicapSystem;
  otherPlayer: boolean = false;
  otherPlayerId: number;
  isModalOpen: boolean = false;

  constructor(private router: Router, private http: HttpClient,
    // private navParams: NavParams,
    private modalCtl: ModalController,
    private loadingCtl: LoadingController,
    private commonprovider: CommonProvider,
    private actionSheetCtl: ActionSheetController,
    private toastCtl: ToastController,
    private actroute: ActivatedRoute,
    private alertCtl: AlertController,
    private navParams: NavParams,
    private keyboard: Keyboard,
    private location: Location,
    private scorecardService: ScorecardService,
    // private events: Events,
    private platform: Platform,
    private playerService: PlayerService,
    private handicapService: HandicapService,
    private playerHomeActions: PlayerHomeActions,
    private flightService: ClubFlightService,
    private hcpMemberService: HandicapMembershipService,
    private playerHomeService: PlayerHomeDataService,
    private mg2uUtil: mygolfUtils,
  ) {
    if (this.router.getCurrentNavigation() && this.router.getCurrentNavigation().extras.state) {
      this.currentPlayer = this.router.getCurrentNavigation().extras.state.currentPlayer;

      this.fromMenu = this.router.getCurrentNavigation().extras.state.fromMenu;
      this.player$ = this.router.getCurrentNavigation().extras.state.player;
      this.subsActive = this.router.getCurrentNavigation().extras.state.subsActive;
      this.peerReviewMode = this.router.getCurrentNavigation().extras.state.peerReviewMode;

    } else {
      this.fromMenu = navParams.get("fromMenu");
      this.player$ = navParams.get('player');
      this.isModalOpen = navParams.get("isModalOpen");
      this.peerReviewMode = navParams.get("peerReviewMode");
    }


    this._initItems();
    this.searchCriteria = this.scorecardService.getSearchCriteria();
    this.getAppAttribute()

  }


  handicapData: any = [];

  private _initItems() {
    this.scorecardList = {
      success: true,
      totalPages: 0,
      currentPage: 0,
      totalItems: 0,
      totalInPage: 0,
      scorecards: []
    };
  }
  //   ngOnInit() {
  //     this.getHandicapSystems();

  //   }

  peerReviewMode: boolean = false;
  ionViewWillEnter() {
    this.refreshHandicapSystem();
    if(this.peerReviewMode) {
      this.openPlayerList();
    } else {
      if (this.selectedPlayerId == undefined) {

      }
      setTimeout(() => {
        if (this.fromMenu === 'menu') this.playerSubs = true;
        if (this.fromMenu === 'friend') {
          if (this.player$) {
            let _playerId;
            this.player$.pipe(take(1),
              map((player: PlayerInfo) => player.playerId))
              .subscribe((playerId) => {
                this.getPlayerHcpList(playerId);
              });
            this.subsActive = true;
          }
        }
        else {
          this.subsActive = true;
          if (this.subsActive) {
            this.refreshAttempted = false;
            if (!this.modalData) {
              let _waitHcpSystem = setInterval(() => {
                if (this.handicapSystem && this.handicapSystem.length > 0) {
                  clearInterval(_waitHcpSystem);
                  this.getPlayerHcpList()
                }
              }, 500)
            }

          }
        }

      }, 750)

    }


  }


  // ionViewDidEnter() {

  // }

  getHcpIdxSubscription() {
    this.playerService.getHcpIdxSubs()
      .subscribe((data: any) => {
        if (!data.ok) {
          return
        } else if (data.ok && data.data.length > 0) {
          this.hcpIdxSubs = data.data;
          this.getPlayerHcpList();
        }
      }), (error) => {
      };
  }


  onRefreshClick(refresher) {
    this.refreshAttempted = false;
    // // this.subsActive = false;
    // if(this.playerSubs) this.subsActive = this.playerSubs;
    this.playerSubs = true;
    this.subsActive = true;
    this.otherPlayer = false;
    this.otherPlayerId = null;
    this.selectedPlayerId = null;
    if (this.playerSubs || this.subsActive)
      this._clearAndRefresh(refresher);
    // this.doRefresh();
  }

  refreshHandicapSystemPromise() {
    return new Promise((resolve, reject) => {
      let _player: PlayerInfo;
      let _playerId;
      if (this.currentPlayer) {
        _player = this.currentPlayer;
      }

      this.handicapSystem = [];
      this.flightService.getHandicapSystemList()
        .subscribe((handicap: Array<HandicapSystem>) => {
          // Array<HandicapSystem>
          if (handicap && handicap.length > 0) {
            this.handicapSystem = handicap;
            handicap.filter((hcp: HandicapSystem) => {
              if (this.currentPlayer && _player && hcp.id === _player.defaultHandicapSystem)
                return true;
              // this.viewHcpSystem = hcp
              // else if(!this.currentPlayer && _player && hcp.id === _player.defaultHandicapSystem)
              // // && this.fromMenu
              //     // this.viewHcpSystem = hcp
              //     return true
              else if ((_player && !_player.defaultHandicapSystem) || !_player) {
                if (hcp.defaultSystem)
                  return true

                // hcp.id.toLowerCase().includes('whs') ||
                // this.viewHcpSystem = hcp
              }
            }).map((hcp: HandicapSystem) => {
              this.viewHcpSystem = hcp
            })
            resolve('handicap system done load : ' + this.handicapSystem)
          } else reject('no handicap system load : ' + handicap)
        })
    })
  }

  refreshPlayerHcpListPromise(handicapSystem) {
    return new Promise((resolve, reject) => {
      this.getPlayerHcpList();
      resolve("done getting player hcp list")
    })
  }

  async doRefresh() {
    const handicapSystem = this.refreshHandicapSystemPromise()
    const refreshPlayerHcpList = this.refreshPlayerHcpListPromise(handicapSystem)
  }

  async onMenuFilterClick() {
    let filter = await this.modalCtl.create(
      {
        component: ScorecardFilterPage
      });
    // filter.onDidDismiss((apply: boolean) => {
    filter.onDidDismiss().then((data: any) => {
      if (data.apply) {
        this._clearAndRefresh(null);
        // this.handicapHistory = new HandicapCalculation();
        this.searchCriteria = data.searchCriteria;
      }
      if (this.searchCriteria.countryId === null || this.searchCriteria.countryId === '') {
        this.selectedCountry = null
      }
    })
    // this.nav.push(ScorecardFilterPage);
    if (this.platform.is('ios') && this.platform.is('capacitor'))
      this.keyboard.hide();
    filter.present();
  }

  async openPlayerList() {
    console.debug("handicap history ", this.handicapHistory, this.currentPlayer);
    let modal = await this.modalCtl.create({
      component: PlayerListPage,

    });
    modal.onDidDismiss().then((data: any) => {

      this.modalData = data.data;
      if (data.data.selected) {
        let _player: PlayerInfo = data.data.player;

        this.refreshAttempted = false;
        if (_player) {
          this.selectedPlayerId = _player.playerId

          // this.handicapHistory = new HandicapCalculation();
          this.handicapSystem.filter((hcpSys) => {
            if (_player.defaultHandicapSystem)
              return hcpSys.id === _player.defaultHandicapSystem
            else hcpSys.id.toLowerCase().includes('whs');
          }).map((hcpSys) => {
            this.viewHcpSystem = hcpSys
          });
          setTimeout(() => {
            this.getPlayerHcpList(_player.playerId, _player.defaultHandicapSystem);
          }, 500);
          this.subsActive = true;
          this.otherPlayer = true;
          this.otherPlayerId = _player.playerId
        }

      } else this.otherPlayer = false;

    })


    modal.present();
  }

  private _requestTrialSubscripion(busy?) {
    if (!busy) {
      busy = this.loadingCtl.create({
        message: "Please wait...",
        showBackdrop: false,
        backdropDismiss: false,
        duration: 5000,
      });
    }
    busy.present().then(() => {
      this.playerService.requestTrialSubs()
        .subscribe((data: HandicapIndexSubscription) => {
          // if (data.length > 0) {
          let hIS = data[0];
          setTimeout(() => {
            // this.hcpIdxSubs = data;
          }, 250);
          this.playerService.genHcpCalc()
            .subscribe((data: any) => {
              this.refresh();
            })

          // }
          // busy.dismiss(memberships);
          setTimeout(() => {
            if (busy) busy.dismiss().then(() => {
              MessageDisplayUtil.showMessageToast('Thank you for subscribing',
                this.platform, this.toastCtl, 3000, "bottom")
              this.subsActive = true;

              // if(this.hcpIdxSubs)

            })
          }, 450);

        }, (error) => {
          if (busy) busy.dismiss().then(() => {
              if (error) {
                let msg = MessageDisplayUtil.getErrorMessage(error);
                MessageDisplayUtil.displayErrorAlert(this.alertCtl, "Subscription",
                  msg, "OK");
              }

            })
        }, () => {
          // if(busy) busy.dismiss().then();
          // this.playerHomeActions.refreshForcefully();
          // this._refreshMemberships();
        });
    });
    // });
  }


  async promptSubscription() {
    let confirm = await this.alertCtl.create({
      header: 'Free Trial',
      message: 'You are entitled to subscribe for free 3-months trial',
      buttons: [
        {
          text: 'Not Now',
          role: "cancel",
          handler: () => {
            confirm.dismiss();
            return false;
          }
        },
        {
          text: 'Use Trial',
          handler: () => {
            confirm.dismiss()
              .then(() => {
                this._requestTrialSubscripion();
              });
            return false;
          }
        }
      ]
    });
    confirm.present();
  }


  refresh() {
    this.playerHomeActions.refreshForcefully();
    this.onRefreshClick(null);
  }

  onSearchInput() {
    if (this.searchPlayers) {
      this._searchPlayer();
    } else this._clearAndRefresh(null);
    // this._clearAndRefresh(null);
  }


  async onScorecardClick(event, item: PlainScoreCard) {
    //Need to get the full scorecard or not
    let loader = await this.loadingCtl.create({
      message: "Getting scorecard...",
      showBackdrop: false
    });
    loader.present().then(() => {
      this.scorecardService.getScorecard(item.gameRoundId)
        .subscribe((scorecard: PlainScoreCard) => {
          loader.dismiss().then(() => {
            if (scorecard) {
              this.scorecardList.scorecards.forEach((sc, idx) => {
                if (sc.gameRoundId === scorecard.gameRoundId) {
                  this.scorecardList.scorecards[idx] = scorecard;
                }
              });

              this.router.navigate(['scorecard-display'], {
                queryParams: {
                  scorecard: JSON.stringify(scorecard),
                  currentPlayer: JSON.stringify(this.currentPlayer), editing: JSON.stringify(true)
                }
              })
              // this.nav.push(ScorecardDisplayPage, {
              //     scorecard: scorecard,
              //     currentPlayer: this.currentPlayer,
              //     editing  : true
              // });
            }

          });
        }, (error) => {
          loader.dismiss().then(() => {
            let msg = MessageDisplayUtil.getErrorMessage(error, "Error getting scorecard list");
            MessageDisplayUtil.showErrorToast(msg, this.platform, this.toastCtl, 5000, "bottom");
          });
        }, () => {

        });

    });

  }

  private async _refresh(refresher, infinite) {
    this.refreshAttempted = false;

    let loader = await this.loadingCtl.create({
      showBackdrop: false,
      message: "Loading MG2U history..."
    });
    loader.present().then(() => {
      this.handicapService.getHandicapHistory().subscribe((data: Array<HandicapCalculation>) => {
        // let gameRounds: any;
        this.handicapHistory = data[0];
        loader.dismiss().then(() => {

          if (this.handicapHistory.gameRounds) {

            this.gameRounds = this.handicapHistory.gameRounds;
            this.gameRounds.sort((a, b) => {
              if (a.roundDate < b.roundDate)
                return 1;
              else if (a.roundDate > b.roundDate)
                return -1;
              else return 0;
            });
          }
        });

      }, (error) => {
        loader.dismiss().then(() => {
          let msg = MessageDisplayUtil.getErrorMessage(error, "Error listing handicap history");
          MessageDisplayUtil.showErrorToast(msg, this.platform, this.toastCtl, 5000, "bottom");
        });
      }, () => {
        this.refreshAttempted = true;

        if (refresher) refresher.complete();
        if (infinite) {
          infinite.complete();
        }
      })
    });

  }
  doInfinite(infinite) {

    if (this.isMore()) {
      this._refresh(null, infinite);
    }
    else {
      infinite.target.complete();
      // infinite.enable(false);
    }

  }


  toggleInfiniteScroll() {
    this.infiniteScroll.disabled = !this.infiniteScroll.disabled;
  }
  onListTypeChange(event) {
    this._clearAndRefresh(null);
  }


  public isMore() {
    return this.scorecardList.totalPages > 0
      && this.scorecardList.currentPage < this.scorecardList.totalPages;
  }




  onHomeClick() {
    // this.router.navigate(["/tabs/player-home"]);
    if (this.isModalOpen) {
      this.modalCtl.dismiss("handicapHistory")
    }
    this.location.back();
  }

  async onChangeHcpSystem() {
    let _playerId = null;
    if (this.selectedPlayerId && this.otherPlayer) _playerId = this.selectedPlayerId
    else {
      _playerId = this.currentPlayer.playerId;
    }

    let modal = await this.modalCtl.create({
      component: ChangeHcpHistoryComponent,
      cssClass: this.platform.is('mobile') ? 'self-adjustable-modal' : 'self-adjustable-modal-desktop',
      mode: 'ios',
      componentProps: {
        handicapSystem:this.handicapSystem,
        viewHcpSystem:this.viewHcpSystem

      },
    });
    await modal.present().then(() => {
      const height = this.platform.height() - 105;
      document.getElementsByClassName('inner-content')[0]['style'].maxHeight = `${height}px`;
    });
    modal.onDidDismiss().then((d)=>{
      if(d.data){
        this.viewHcpSystem = d.data;
        this.getPlayerHcpList(_playerId, d.data.id);
      }
    });

    // this.refreshHandicapSystem();
    // let _buttons = [];
    // _buttons.push({
    //   text: "View Handicap System"
    // });


    //   this.player$.pipe(take(1),
    //   map((player: PlayerInfo) => player))
    //   .subscribe((player) => {
    //       _playerId = player.playerId
    //   });


    // if (this.handicapSystem && this.handicapSystem.length > 0) {
    //   this.handicapSystem.forEach((hcpSys: HandicapSystem) => {
    //     if (hcpSys.id && hcpSys.derivedByMygolf && this.viewHcpSystem && hcpSys.id !== this.viewHcpSystem.id)
    //       _buttons.push({
    //         text: hcpSys.name + " (" + hcpSys.shortCode + ")",
    //         handler: () => {
    //           this.viewHcpSystem = hcpSys;

    //           this.getPlayerHcpList(_playerId, hcpSys.id);

    //         }
    //       });
    //   })
    // }

    // _buttons.push({
    //   text: 'Cancel',
    //   role: 'cancel', // will always sort to be on the bottom
    //   icon: !this.platform.is('ios') ? 'close' : null,
    //   handler: () => {
    //     actionSheet.dismiss();
    //     return false;
    //   }
    // })
    // let actionSheet = await this.actionSheetCtl.create({
    //   buttons: _buttons,
    // });
    // actionSheet.addButton({
    //     text   : 'Cancel',
    //     role   : 'cancel', // will always sort to be on the bottom
    //     icon   : !this.platform.is('ios') ? 'close' : null,
    //     handler: () => {
    //         actionSheet.dismiss();
    //         return false;
    //     }
    // });
    // actionSheet.present();
    // let actionSheet = this.actionSheetCtl.create({
    //   buttons: [
    //     {
    //       text: 'View Handicap Systemt',


    //       handler: () => {
    //       }
    //     }, {
    //       text: 'World Handicap System 2020 (WHS 2020)',
    //       handler: () => {
    //         this.getplayerCal()
    //       }
    //     },
    //     {
    //       text: 'Cancel',
    //       role: 'cancel',
    //       icon: 'close' ,
    //       handler: () => {
    //       }
    //     }

    //   ]
    // });
    // (await actionSheet).present();
  }

  private _searchPlayer() {
    this.playerService.searchPlayers(this.searchPlayers, true, 1)
      .subscribe(async (playerList: PlayerList) => {
        if (playerList && playerList.players) {
          this.players = playerList.players.filter(p => {
            let excluded = this.playersToExclude.find((pe => {
              return pe.playerId === p.playerId;
            }));
            return !excluded;
          });

          let filter = await this.modalCtl.create({
            component: PlayerListPage,
            componentProps: {
              playerList: playerList
            }
          });
          // filter.onDidDismiss((apply: boolean) => {
          filter.onDidDismiss().then((data: any) => {
            if (data.selected) {
              if (data.player)
                this.selectedPlayerId = data.player.playerId

              this.getPlayerHcpList(data.player.playerId);
            }
            else this._clearAndRefresh(null);
          })
          filter.present();

        }
      });
  }

  //   getplayerCal(){
  //     const headers = new HttpHeaders({
  //       "X-AUTH-TOKEN" : 'ewogICJ1c2VyIiA6IHsKICAgICJ1c2VySWQiIDogODA0MSwKICAgICJ1c2VybmFtZSIgOiAiZGF2aWRAbXlnb2xmMnUuY29tIiwKICAgICJhY3RpdmUiIDogdHJ1ZSwKICAgICJleHBpcmVzIiA6IDE2MjU1NTU1Njg4MzAsCiAgICAidXNlclR5cGUiIDogIlBsYXllciIsCiAgICAicGxheWVySWQiIDogODUxMSwKICAgICJjbHViSWQiIDogbnVsbCwKICAgICJvcmdhbml6ZXJJZCIgOiBudWxsLAogICAgImNhZGR5SWQiIDogbnVsbCwKICAgICJwYXJ0bmVySWQiIDogbnVsbCwKICAgICJhZG1pbiIgOiBmYWxzZSwKICAgICJlbWFpbCIgOiAiZGF2aWRAbXlnb2xmMnUuY29tIiwKICAgICJwaG9uZSIgOiBudWxsLAogICAgIm5hbWUiIDogIkRhdmlkICBCZWNraGFtICIsCiAgICAibmV3QXV0aCIgOiB0cnVlLAogICAgImFsZ29yaXRobSIgOiBudWxsLAogICAgImNvbWJpbmVVc2VybmFtZSIgOiBmYWxzZSwKICAgICJhdXRob3JpdGllcyIgOiBbIHsKICAgICAgIkBjbGFzcyIgOiAiY29tLmJyaXRlc29mdC5teWdvbGYuc2VjdXJpdHkuTXlnb2xmUm9sZSIsCiAgICAgICJhdXRob3JpdHkiIDogIlJPTEVfUExBWUVSIgogICAgfSBdCiAgfSwKICAiYXV0aGVudGljYXRlZCIgOiB0cnVlCn0=.fInveTyb7OsGIkRxyThJcKbsVbWbDkPBhByz0Jx7qnY=',
  //       "Player-Id" : "8511"
  //     });
  //     this.http.get(Apiurl.RoutePath + Apiurl.playerHandicapCalculations, {headers : headers}).subscribe(res => {
  //       this.handicapData = res;
  //     })
  //   }


  refreshHandicapSystem() {
    let _player: PlayerInfo;
    let _playerId;

    // if(this.player$) {
    //     // this.player$.take(1)
    //     // .map((player: PlayerInfo) => player)
    //     // .subscribe((player) => {
    //     //     _player = player;
    //     // });
    //     _player = this.player$;
    //     // this.subsActive = true;
    // } else if(this.currentPlayer) {
    //     _player = this.currentPlayer
    // }
    if (this.currentPlayer) {
      _player = this.currentPlayer;
    }

    this.handicapSystem = [];
    this.flightService.getHandicapSystemList()
      .subscribe((handicap: Array<HandicapSystem>) => {
        // Array<HandicapSystem>

        if (handicap && handicap.length > 0) {
          this.handicapSystem = handicap;

          handicap.filter((hcp: HandicapSystem) => {

            if (this.currentPlayer && _player && hcp.id === _player.defaultHandicapSystem?.id)
              return true;
              else if(this.fromMenu === 'menu' && this.currentPlayer && _player && _player.defaultHandicapSystem === hcp.id)
                  return true;
            // this.viewHcpSystem = hcp
            // else if(!this.currentPlayer && _player && hcp.id === _player.defaultHandicapSystem)
            // // && this.fromMenu
            //     // this.viewHcpSystem = hcp
            //     return true
            else if ((_player && !_player.defaultHandicapSystem) || !_player) {
              if (hcp.defaultSystem)
                return true

              // hcp.id.toLowerCase().includes('whs') ||
              // this.viewHcpSystem = hcp
            }
          }).map((hcp: HandicapSystem) => {
            this.viewHcpSystem = hcp
          })
        }
      })
  }

  private _clearAndRefresh(refresher) {
    this._initItems();
    // this._getCountryList();
    // this.loader = this.loadingCtl.create({
    //     content     : "Getting your handicap...",
    //     showBackdrop: false
    // });
    this.getPlayerHcpList();
    // this._refresh(refresher, null);
  }
  showInfo(handicapSystem: string) {
    if (handicapSystem !== 'WHS2020') return false;
    else return true;
  }

  getHandicapSystemDetail(handicapSystem: string, attribute?: string) {
    let _hcpSysName;
    let _hcpSysCode;
    if (!this.handicapSystem || (this.handicapSystem && this.handicapSystem.length === 0)) return;
    if (!handicapSystem) {
      this.handicapSystem.filter((hcpSys) => {
        if (hcpSys.id === 'USGA_OLD') {
          _hcpSysName = hcpSys.name
          _hcpSysCode = hcpSys.shortCode
        }
      })
    } else if (handicapSystem) {
      this.handicapSystem.filter((hcpSys) => {
        if (hcpSys.id === handicapSystem) {
          _hcpSysName = hcpSys.name
          _hcpSysCode = hcpSys.shortCode
        }
      })
    }
    if (attribute === 'code') return _hcpSysCode
    else return _hcpSysName
  }


  toggleSeeMore() {
    this.seeMore = !this.seeMore;
  }



  getFrontBack(round: HandicapGameRound, adjusted: boolean = false) {
    let first: number = 0;
    let second: number = 0;
    round.scores.forEach(a => {
      if (a.holeNo <= 9) {
        if (!adjusted) first += a.grossScore
        else first += a.adjustedScore
      }
      else if (a.holeNo > 9) {
        if (!adjusted) second += a.grossScore
        else second += a.adjustedScore
      }
    });

    return first + " | " + second
    // round.scores.reduce((a,b) => )
  }

  async getPlayerHcpList(playerId?: number, handicapSystem?: string) {
    // HandicapSystem
    this.refreshAttempted = false;


    if (this.otherPlayer) this.otherPlayerId = playerId;
    let selPlayerId: number;
    let _playerDefHcpSystem;
    this.handicapHistory = null;
    if ((playerId)) {
      selPlayerId = playerId;
    }
    else if (!(playerId) && this.currentPlayer) {

      selPlayerId = this.currentPlayer.playerId
      if (!this.viewHcpSystem) _playerDefHcpSystem = this.currentPlayer.defaultHandicapSystem;
      else {
        _playerDefHcpSystem = this.currentPlayer.defaultHandicapSystem;
        this.handicapSystem.filter((hcpSys) => {
          return hcpSys.id === this.currentPlayer.defaultHandicapSystem;
        }).map((hcpSys) => {
          this.viewHcpSystem = hcpSys
        })
      }
      // this.player$.take(1)
      // .subscribe(player => {
      //     selPlayerId = player.playerId
      // });
      // this.player$.take(1)
      // .map((player: PlayerInfo) => player.playerId)
      // .subscribe((playerId) => {
      //     selPlayerId = playerIdG
      // });
    } else if (!(playerId) && this.player$) {
      this.player$.pipe(take(1),
        map((player: PlayerInfo) => player))
        .subscribe((player) => {
          selPlayerId = player.playerId;
          if (!this.viewHcpSystem) _playerDefHcpSystem = player.defaultHandicapSystem;
          else {
            _playerDefHcpSystem = player.defaultHandicapSystem
            this.handicapSystem.filter((hcpSys) => {
              return hcpSys.id === this.currentPlayer.defaultHandicapSystem;
            }).map((hcpSys) => {
              this.viewHcpSystem = hcpSys
            })
          }
        }, (error)=>{
          // if(this.refresher) this.refresher?.target.complete();
        });
    }

    let loader = null;
    let _hcpSysName = '';


    if (this.viewHcpSystem) _hcpSysName = this.viewHcpSystem.name
    if (!this.loader || this.loader === null) {
      loader = await this.loadingCtl.create({
        // content     : "Getting MG2U handicap...",
        message: "Getting handicap...",
        // " + _hcpSysName + "
        showBackdrop: false
      });
    }
    else loader = this.loader;

    this.dtLength = 0;
    let _hcpSystem: HandicapSystem = {};
    if (handicapSystem) _hcpSystem.id = handicapSystem;
    else if (this.viewHcpSystem && !handicapSystem) _hcpSystem = this.viewHcpSystem;
    else if (!this.viewHcpSystem && !handicapSystem) {
      if (_playerDefHcpSystem && (!this.viewHcpSystem && !handicapSystem)) {
        _hcpSystem.id = _playerDefHcpSystem
        // if(this.handicapSystem)
        // this.handicapSystem.filter((hcpSys)=>{
        //     return hcpSys.id === _playerDefHcpSystem
        // }).map((hcpSys)=>{
        //     this.viewHcpSystem = hcpSys;
        // })
      }
      // if(this.handicapSystem)
      // this.handicapSystem.filter((hcpSys)=>{
      //     if(hcpSys.id === _playerDefHcpSystem)
      //         return true;
      //     else return false;
      // }).map((hcpSys)=>{
      //     _hcpSystem = hcpSys;
      // })
    }

    loader.present().then(() => {
      //   const setID :any = selPlayerId
      //   const headers = new HttpHeaders({
      //     "X-AUTH-TOKEN": "ewogICJ1c2VyIiA6IHsKICAgICJ1c2VySWQiIDogODA0MSwKICAgICJ1c2VybmFtZSIgOiAiZGF2aWRAbXlnb2xmMnUuY29tIiwKICAgICJhY3RpdmUiIDogdHJ1ZSwKICAgICJleHBpcmVzIiA6IDE2MjU1NTU1Njg4MzAsCiAgICAidXNlclR5cGUiIDogIlBsYXllciIsCiAgICAicGxheWVySWQiIDogODUxMSwKICAgICJjbHViSWQiIDogbnVsbCwKICAgICJvcmdhbml6ZXJJZCIgOiBudWxsLAogICAgImNhZGR5SWQiIDogbnVsbCwKICAgICJwYXJ0bmVySWQiIDogbnVsbCwKICAgICJhZG1pbiIgOiBmYWxzZSwKICAgICJlbWFpbCIgOiAiZGF2aWRAbXlnb2xmMnUuY29tIiwKICAgICJwaG9uZSIgOiBudWxsLAogICAgIm5hbWUiIDogIkRhdmlkICBCZWNraGFtICIsCiAgICAibmV3QXV0aCIgOiB0cnVlLAogICAgImFsZ29yaXRobSIgOiBudWxsLAogICAgImNvbWJpbmVVc2VybmFtZSIgOiBmYWxzZSwKICAgICJhdXRob3JpdGllcyIgOiBbIHsKICAgICAgIkBjbGFzcyIgOiAiY29tLmJyaXRlc29mdC5teWdvbGYuc2VjdXJpdHkuTXlnb2xmUm9sZSIsCiAgICAgICJhdXRob3JpdHkiIDogIlJPTEVfUExBWUVSIgogICAgfSBdCiAgfSwKICAiYXV0aGVudGljYXRlZCIgOiB0cnVlCn0=.fInveTyb7OsGIkRxyThJcKbsVbWbDkPBhByz0Jx7qnY=",
      //     "Player-Id" : setID
      // })
      this.handicapService.getHandicapHistory(selPlayerId)
        .subscribe((data: Array<HandicapCalculation>) => {
          if (data.length > 0) {
            this.dtLength = data.length;

            // this.refreshAttempted = true;
            if (_hcpSystem && data.length > 1)
              data = data.filter((hcpCalc: HandicapCalculation) => {
                return hcpCalc.handicapSystem === _hcpSystem.id;
              });
            else if (_hcpSystem && data.length === 1) {
              data = data.filter((hcpCalc: HandicapCalculation) => {
                let _hcpSys: HandicapSystem;
                _hcpSys = this.handicapSystem.find((hcpSys) => {
                  return hcpSys === hcpCalc.handicapSystem
                })
                if (_hcpSys && _hcpSys.derivedByMygolf) return true
                else return false
              });
            }

            if (!this.viewHcpSystem || !handicapSystem) {
              // this.handicapSystem
              this.handicapSystem.filter((hcpSys) => {
                return hcpSys.id === _playerDefHcpSystem
              }).map((hcpSys) => {
                this.viewHcpSystem = hcpSys
              })
            }
            this.handicapHistory = data[0];
            console.log(this.handicapHistory, 'sumit sumit');

            if (this.handicapHistory && this.handicapHistory.gameRounds) {

              this.gameRounds = this.handicapHistory.gameRounds;
              this.gameRounds.sort((a, b) => {
                if (a.roundDate < b.roundDate)
                  return 1;
                else if (a.roundDate > b.roundDate)
                  return -1;
                else return 0;
              });
            }
          }
          else {
            this.dtLength = 0;
            this.gameRounds = null;
            this.handicapHistory = null;
          }
          if (loader)
            loader.dismiss().then(() => {
              // let gameRounds: any;

              this.refreshAttempted = true;
            })
        if(this.refresher) this.refresher?.target.complete();
        }, (error) => {
          if(this.refresher) this.refresher?.target.complete();
          if (error && loader) loader.dismiss().then(() => {
            this.refreshAttempted = true;
            let errorMsg;
            let msg1 = MessageDisplayUtil.getErrorMessage(error, "Error reaching server");
            if (error && !error.ok) {
              errorMsg = "Error reaching server"
              MessageDisplayUtil.showErrorToast(errorMsg, this.platform, this.toastCtl, 5000, 'bottom')
            }
            // let msg2 = MessageDisplayUtil.getError(error,this);

          })
        }, () => {
          this.refreshAttempted = true;
        }
        )
    })

  }


  onClubHandicap() {
    this.handicapService.getClubHandicap(62).subscribe((data: Array<ClubHandicap>) => {
      // let gameRounds: any;
      this.clubHandicap = data;
      // if(this.handicapHistory.gameRounds) {

      //     this.gameRounds = this.handicapHistory.gameRounds;
      //     this.gameRounds.sort((a, b)=>{
      //         if(a.roundDate < b.roundDate)
      //             return 1;
      //         else if(a.roundDate > b.roundDate)
      //             return -1;
      //         else return 0;
      //     });
      // }
    })
  }

  goHistoryDetails(gameRound: HandicapGameRound) {
    // this.nav.push(HandicapHistoryDetailsPage, {
    //     gameRound: gameRound
    //     // currentPlayer: this.currentPlayer,
    //     // editing  : true
    // });
    this.navigationExtras.state = gameRound;
    let params: NavigationExtras = {
      state: {
        gameRound: gameRound,
        currentPlayer: this.currentPlayer,
        fromMenu: this.fromMenu,
        subsActive: this.subsActive,
        player: this.player$,
      }
    }

    this.router.navigate(['/handicap-history-details'], params)
  }

  getActualDiff(round: HandicapGameRound) {
    if (!round) return;
    return (round.scoreDifferential + round.cumulativeESR);
  }

  getTeeColor(color: string) {
    if (color === 'White') {
      return 'light'
    } else if (color === 'Red') {
      return 'danger'
    } else if (color === 'Black') {
      return 'dark'
    } else if (color === 'Blue') {
      return 'secondary'
    } else if (color === 'Gold') {
      return 'gold'
    }
    else return 'secondary'
  }

  async onMoreMenuItems() {

    let _dataList = [{
      id: 'refresh',
      name: 'Refresh',
      iconUrl: 'assets/image/userCircle.png'
    },{
      id: 'peerReview',
      name: 'Peer Review',
      iconUrl: 'assets/image/userCircle.png'
    },{
      id: 'myHandicap',
      name: 'Show My Handicap',
      iconUrl: 'assets/icons/book.png'
    },{
      id: 'whsSubscription',
      name: 'National Handicap Subscription',
      iconUrl: 'assets/icons/book.png'
    },{
      id: 'hcpCalculator',
      name: 'Handicap Calculator',
      iconUrl: 'assets/image/icons/handicapCalculater.svg'
    }]
      const modal = await this.modalCtl.create({
        mode: 'ios',
        component: CommonPullupMenuComponent,
        cssClass: 'self-adjustable-modal',
        componentProps: {
            app: null,
            dataList: _dataList,
            mode: 'common',
            // headerTitle: 'Competition League',
            // subTitle: this.leagueRounds?this.leagueRounds[0].seasonName:'',
        }
    })
    await modal.present().then(() => {
        const height = this.platform.height() - 250;
        document.getElementsByClassName('inner-content')[0]['style'].maxHeight = `${height}px`;
    });
    modal.onDidDismiss().then(async (data: any) => {
      console.debug("pullup dismiss", data)
      if(data) {
        if(data?.data?.id === 'peerReview') {
          this.peerReviewMode = true;
          this.otherPlayer = true;
          this.openPlayerList();
        } else if(data?.data?.id === 'myHandicap') {
          this.peerReviewMode = false;
          this.otherPlayer = false;
          this.selectedPlayerId = this.currentPlayer?.playerId;
          this.doRefresh();
          // this.ionViewWillEnter();
        } else if(data?.data?.id === 'whsSubscription') {
          this.openHandicapMembership();
        } else if(data?.data?.id === 'refresh') {
          this.onClickRefresh();

        }  else if(data?.data?.id === 'hcpCalculator') {
          this.goHandicapCalculator();

        }
      }
    })
  }

  refresher: any;
  onClickRefresh(refresher?) {
    console.debug("refreshing handicap", this.currentPlayer, this.selectedPlayerId)
    if(refresher) this.refresher = refresher;
    if(this.currentPlayer?.playerId === this.selectedPlayerId) {
      this.doRefresh();
    } else {
      this.getPlayerHcpList(this.selectedPlayerId)
    }
  }

  refreshHcp() {
    this.doRefresh();
    // this.selectedPlayerId = _player.playerId

    //       // this.handicapHistory = new HandicapCalculation();
    //       this.handicapSystem.filter((hcpSys) => {
    //         if (_player.defaultHandicapSystem)
    //           return hcpSys.id === _player.defaultHandicapSystem
    //         else hcpSys.id.toLowerCase().includes('whs');
    //       }).map((hcpSys) => {
    //         this.viewHcpSystem = hcpSys
    //       });
    //       setTimeout(() => {
    //         this.getPlayerHcpList(_player.playerId, _player.defaultHandicapSystem);
    //       }, 500);
    //       this.subsActive = true;
    //       this.otherPlayer = true;
    //       this.otherPlayerId = _player.playerId
  }


  async openHandicapMembership() {
    let _player: PlayerInfo = this.currentPlayer;



    let _playerId = _player.playerId || _player.id;
    let _params = {
      partnerId: null,
      programId: null,
      startDate: null,
      endDate: null,
      playerId: _playerId,
      approvedOrNot: true,
      pageSize: 30,
    }

    this.hcpMemberService.getMembershipApplications(_params)
      .then(async (result: any) => {

        if (result && result.status === 'success') {
          if (result && result.data && result.data.length > 1) {
            let modal = await this.modalCtl.create({
              component: PlayerVoucherPage,
              componentProps: {
                title: 'Handicap Membership',
                type: 'handicap',
                player: _player,
                player$: this.player$,
                forBooking: false,
                fromClub: false,
                who: 'player',
                showPlayerCard: true,
              }
            })
            modal.present();
          } else if (result && result.data && result.data.length === 1) {
            let modal = await this.modalCtl.create({
              component: PlayerVoucherPage,
              componentProps: {
                title: 'Handicap Membership',
                type: 'handicap',
                player: _player,
                player$: this.player$,
                forBooking: false,
                fromClub: false,
                who: 'player',
                showPlayerCard: true,
                application: result.data[0],
                newMode: true,
              }
            })
            modal.present();
          } else {
            let modal = await this.modalCtl.create({
              component: PlayerVoucherPage,
              componentProps: {
                title: 'Handicap Membership',
                type: 'handicap',
                player: _player,
                player$: this.player$,
                forBooking: false,
                fromClub: false,
                who: 'player',
                showPlayerCard: true,
                newMode: true
              }
            })
            modal.present();
          }
        }
      }).catch((error) => {

      })


  }


  getBtnTbox(color: string) {
    let tboxStyle: string;

    if (color === 'White') {
      return 'button-teebox ' + 'button-teebox-white'
    } else return 'button-teebox'
  }

  showMore(round: HandicapGameRoundExt) {
    return round?.showMore;
  }

  toggleShowMore(round: HandicapGameRoundExt) {
    if(!round?.showMore) round.showMore = true
    else {
      round.showMore = !round.showMore
    }
  }

  showUsedOnly: boolean = false;
  getFilteredGameRounds() {
    let _filteredList = this.gameRounds;
    if(this.showUsedOnly) {
      _filteredList = this.gameRounds.filter((round) => {
        return round?.used;
      })
    }
    return _filteredList
  }

  showMoreAll: boolean = false;
  onToggleShowMoreAll() {
    if(this.showMoreAll)
    this.getFilteredGameRounds().forEach((round) => {
      round.showMore = true
    })
    else this.getFilteredGameRounds().forEach((round) => {
      round.showMore = false
    })
  }

  async onChangeDefaultHcpSystem() {

    let _playerId = null;
    _playerId = this.currentPlayer?.playerId || this.selectedPlayerId;

    let _currDefault = this.handicapSystem.find((hcpSys)=>{
      return hcpSys?.id === this.currentPlayer?.defaultHandicapSystem
    })
    let _hcpSystemList = this.handicapSystem.filter((hcpSys) => {
      return hcpSys?.derivedByMygolf && hcpSys?.id !== _currDefault?.id
    });
    console.debug("on changing default hcp system", this.currentPlayer, _currDefault, _hcpSystemList, this.handicapSystem, this.player$);


    let modal = await this.modalCtl.create({
      component: ChangeHcpHistoryComponent,
      cssClass: this.platform.is('mobile') ? 'self-adjustable-modal' : 'self-adjustable-modal-desktop',
      mode: 'ios',
      componentProps: {
        handicapSystem: _hcpSystemList,
        viewHcpSystem: _currDefault,
        headerTitle: 'Change Default Handicap System',
      },
    });
    await modal.present().then(() => {
      const height = this.platform.height() - 105;
      document.getElementsByClassName('inner-content')[0]['style'].maxHeight = `${height}px`;
    });
    modal.onDidDismiss().then((d)=>{
      console.debug("on change def hcp system", d)
      if(d.data){
        this.updatePlayerDefaultHcp(d.data);
        // this.viewHcpSystem = d.data;
        // this.getPlayerHcpList(_playerId, d.data.id);
      }
    });
  }

  public playerHomeInfo$: Observable<PlayerHomeInfo>;
  async updatePlayerDefaultHcp(handicapSystem: HandicapSystem) {
    let _player: PlayerInfo;
    if(this.currentPlayer) _player = JsonService.clone(this.currentPlayer);
    // this.player$.pipe(take(1))
    //   .subscribe((player: PlayerInfo) => {
    //     _player = JsonService.clone(player);
    //     if (handicapSystem) player.defaultHandicapSystem = handicapSystem.id
    //   });
    let busy = await this.loadingCtl.create({
cssClass: 'custom-loading',
      message: 'Setting default handicap system...' + handicapSystem.id + ',' + _player
    });
    if (handicapSystem) _player.defaultHandicapSystem = handicapSystem.id
    this.playerHomeActions.updatePlayerProfile(_player, true)
      .subscribe((result: boolean) => {
        if (busy) {
          busy.dismiss().then(() => {
            // this.playerHomeInfo$ = this.playerHomeService.playerHomeInfo().pipe(filter(Boolean)
            // , map((playerHome: PlayerHomeInfo) => {

            // console.debug("updated player def handicap system [00]", playerHome.player)
            //   return playerHome.player}));
            // this.player$ = this.playerHomeInfo$
            //   .pipe(filter(Boolean)
            //     , map((playerHome: PlayerHomeInfo) => {

            //     console.debug("updated player def handicap system [0]", playerHome.player)
            //       return playerHome.player}));
            if (result) {
              this.playerService.getHomeInfo()
              .subscribe((data: PlayerHomeInfo) => {
                if(data) this.currentPlayer = data?.player;
                this.playerHomeActions.setNeedRefresh(true);
                this.playerHomeActions.refreshHomeInfo();
              })
              MessageDisplayUtil.showMessageToast('Successfully changed Default Handicap System', this.platform, this.toastCtl, 3000, 'bottom');
              //
              // this.refreshProfile();
              // setTimeout(()=>{
              //     this.viewCtrl.dismiss();
              // },1000)
            }
          });
        }
      }, (error) => {
        if (busy) {
          busy.dismiss().then(() => {
            let msg = MessageDisplayUtil.getErrorMessage(error, 'Error setting default handicap system');
            MessageDisplayUtil.showErrorToast(msg, this.platform, this.toastCtl, 5000, 'bottom');
          })
        }
      })
  }


    appAttribute: any;
    subAppAttribute: Subscription;
    getAppAttribute() {
      if (this.subAppAttribute) return;
      this.subAppAttribute = this.flightService.getAppAttributes().subscribe((data: any) => {
        if (data) {
          this.mg2uUtil.setAppAttributes(data);
          data
            .filter(d => {
              return d.page === 'playerHome';
            })
            .map(d => {
              this.appAttribute = d;
            });

          if (this.appAttribute) {
            // let _maintenance = this.appAttribute.maintenance;
            if (this.appAttribute.maintenance) {
              // this.displayMaintenance(this.appAttribute);
            }
            // let _announcement = this.appAttribute.annoucement;
            if (this.appAttribute.announcement) {
              // this.displayAnnouncement(this.appAttribute);
            }
          }
        }
      });
    }
  goHandicapCalculator() {

    if (!this.appAttribute) return;
    let _url = this.appAttribute?.hcpCalculatorURL;
    let _playerId: number = this.currentPlayer?.playerId || this.selectedPlayerId;
      if (_playerId) _url += `?playerId=${_playerId}`;
    // this.player$.pipe(take(1)).subscribe(player => {
    //   _playerId = player.playerId || player.id;
    //   if (_playerId) _url += `?playerId=${_playerId}`;
    // });

    window.open(_url, '_system');
  }


}
